
import Technology from "./technology.vue";
export default (Application) => {
    let vce = Application.proc.make('VueCustomElement')
    let auth = Application.proc.make('Auth')
    vce.createApp({
        name: "technology-editor",
        category: "工具",
        alias: "工艺编辑器",
        singleton: true,
        showTitle: false,
        befor:()=>{
            return auth.isAdmin() && auth.isLogined
        }
    }, Technology)

}